import { dew as _extractDew } from "../../utils/formatters/extract.js";
import { dew as _transactionRequestDew } from "../../utils/formatters/transactionRequest.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.sendUnsignedTransaction = void 0;
  const extract_js_1 = _extractDew();
  const transactionRequest_js_1 = _transactionRequestDew();
  async function sendUnsignedTransaction(client, args) {
    const {
      accessList,
      data,
      from,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value,
      ...rest
    } = args;
    const chainFormat = client.chain?.formatters?.transactionRequest?.format;
    const format = chainFormat || transactionRequest_js_1.formatTransactionRequest;
    const request = format({
      ...(0, extract_js_1.extract)(rest, {
        format: chainFormat
      }),
      accessList,
      data,
      from,
      gas,
      gasPrice,
      maxFeePerGas,
      maxPriorityFeePerGas,
      nonce,
      to,
      value
    });
    const hash = await client.request({
      method: "eth_sendUnsignedTransaction",
      params: [request]
    });
    return hash;
  }
  exports.sendUnsignedTransaction = sendUnsignedTransaction;
  //# sourceMappingURL=sendUnsignedTransaction.js.map
  return exports;
}